import './src/styles/global.scss'

import { WithRegisterDialog } from './src/components/shared/RegisterDialog'

export const wrapRootElement = ({ element }) => {
  // @ts-ignore
  return <WithRegisterDialog>{element}</WithRegisterDialog>;
};